import { render, staticRenderFns } from "./knowledgeCorner.vue?vue&type=template&id=78c6ce32&scoped=true"
import script from "./knowledgeCorner.vue?vue&type=script&lang=js"
export * from "./knowledgeCorner.vue?vue&type=script&lang=js"
import style0 from "./knowledgeCorner.vue?vue&type=style&index=0&id=78c6ce32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c6ce32",
  null
  
)

export default component.exports